export const id = {
  title: '',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Fungsi',
      value: 'Identifikasi area tutupan pohon',
    },
    {
      label: 'Resolusi',
      value: '30×30 meter',
    },
    {
      label: 'Cakupan geografis',
      value: 'Lahan global (tidak termasuk kepulauan Antartika dan Arktik)',
    },
    {
      label: 'Sumber',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available from: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Frekuensi pembaruan',
      value: '',
    },
    {
      label: 'Tanggal konten',
      value: '2000 & 2010',
    },
    {
      label: 'Peringatan',
      value:
        'Untuk tujuan penelitian ini, "tutupan pohon" didefinisikan sebagai semua tumbuhan dengan tinggi di atas 5 meter. "Tutupan pohon" adalah kehadiran biofisik dari pohon dan dapat berupa hutan alami atau perkebunan yang ada di rentang kepadatan kanopi.',
    },
    {
      label: 'Lisensi',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Data set ini, sebuah kolaborasi antara lab GLAD (Global Land Analysis & Discovery) di University of Maryland, Google, USGS, dan NASA, menampilkan tutupan pohon di semua lahan global (kecuali Antarktika dan sejumlah kepulauan Arktik) untuk tahun 2000 dan 2010 di resolusi 30 x 30 meter. "Persen tutupan pohon" diartikan sebagai tutupan kanopi permukaan tanah dan berkode warna berdasarkan braket kepadatan (lihat legenda).\n\nData di lapisan ini dihasilkan menggunakan pencitraan satelit multispektral dari sensor thematic mapper plus (ETM+) Landsat 7. Observasi permukaan terbuka dari lebih dari 600.000 citra dianalisa menggunakan Google Earth Engine, sebuah platform awan untuk observasi bumi dan analisis data, untuk menentukan tutupan pohon per piksel menggunakan algoritme pembelajaran terbimbing.\n\nKepadatan kanopi tutupan pohon pada data yang ditampilkan bervariasi menurut seleksi - gunakan legenda pada peta untuk mengganti batas kepadatan kanopi tutupan pohon minimal.',
  },
  citation: {
    label: 'Rujukan',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
